<template>
    <div class="pagination">
        <button :disabled="currentPage === 1" @click="goToPage(currentPage - 1)"><</button>
        <button
            v-for="page in totalPages"
            :key="page"
            :class="{ active: currentPage === page }"
            @click="goToPage(page)"
        >
            {{ page }}
        </button>
        <button :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">></button>
    </div>
</template>
<script>
    export default {
        name: "Pagination",
        props: {
            totalItems: {
                type: Number,
                required: true,
            },
            pageSize: {
                type: Number,
                default: 10,
            },
            modelValue: {
                type: Number,
                default: 1,
            },
        },
        emits: ["update:modelValue", "page-change"],
        computed: {
            totalPages() {
                return Math.ceil(this.totalItems / this.pageSize) || 1;
            },
            currentPage: {
                get() {
                    return this.modelValue;
                },
                set(val) {
                    if (val < 1) val = 1;
                    if (val > this.totalPages) val = this.totalPages;
                    this.$emit("update:modelValue", val);
                    this.$emit("page-change", val);
                },
            },
        },
        methods: {
            goToPage(page) {
                this.currentPage = page;
            },
        },
    };
</script>
<style scoped>
    .pagination button.active {
        background-color: #1890ff;
        color: white;
    }
    .pagination button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
</style>
